<template>
  <div class="ballot-text" v-html="safeHtml" />
</template>

<script setup>
import { computed } from 'vue'
import DOMPurify from 'dompurify'

const props = defineProps({
  component: { type: Object, required: true },
  shareholder: { type: Object, default: () => ({}) },
  mode: { type: String, default: 'vote' },
  form: { type: Object, default: null },
})

const safeHtml = computed(() =>
  DOMPurify.sanitize(props.component.props?.html || ''),
)
</script>

<style scoped>
.ballot-text {
  line-height: 1.6;
}
.ballot-text :deep(h1),
.ballot-text :deep(h2),
.ballot-text :deep(h3) {
  margin-bottom: 8px;
}
.ballot-text :deep(p) {
  margin-bottom: 8px;
}
.ballot-text :deep(ul),
.ballot-text :deep(ol) {
  padding-left: 24px;
  margin-bottom: 8px;
}
</style>
